import { render, staticRenderFns } from "./kd.vue?vue&type=template&id=66b1b044&scoped=true"
import script from "./kd.vue?vue&type=script&lang=js"
export * from "./kd.vue?vue&type=script&lang=js"
import style0 from "./kd.vue?vue&type=style&index=0&id=66b1b044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1b044",
  null
  
)

export default component.exports